import { format } from 'd3-format';

export const dateFormats = Object.freeze( {
    DAY: '%e',
    DAY_AND_MONTH: '%e %b',
    MONTH: '%b',
    STANDARD_DATE: '%Y-%m-%d'
} );

export const tickFormats = Object.freeze( {
    NO_PRECISION: format( '.0f' ),
    STANDARD_PRECISION: format( '.1f' )
} );

export const tickOptions = Object.freeze( {
    X_NUM_TICKS: 10,
    Y_NUM_TICKS: 2
} );

/* Negative areas in streamgraphs/stacked area chart plot above the zero axis-line when their value is zero. */
export const NEGATIVE_ZERO = -0.000001;
export const PADDING_CHARTS = 30;
